import { useState, useEffect, useCallback } from "react";
import { fetcher } from "../fetcher";
import useUser from "../../hooks/user/useUser";
import { IUserData } from "../../interfaces/user/IUserData";

export function useSpecialistFollow({
  specialistData,
}: {
  specialistData: IUserData;
}) {
  const { user } = useUser();
  const [isFollowingCoach, setIsFollowingCoach] = useState<boolean>(false);
  const [loadingFollowBtn, setIsLoadingFollowBtn] = useState<boolean>(true);
  const isFollowing = useCallback(async () => {
    if (user?.token) {
      const res = await fetcher(`users/${specialistData.id}/following`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      }).catch((e: Error) => {
        console.error(e);
      });
      setIsFollowingCoach(Boolean(res));
      setIsLoadingFollowBtn(false);
      return res;
    }
  }, [specialistData, user]);

  useEffect(() => {
    isFollowing().catch((e: Error) => {
      console.error(e);
    });
  }, [user, isFollowing]);

  if (!loadingFollowBtn) {
    return { isFollowingCoach, loadingFollowBtn };
  }
}
